if (document.getElementById('groups-map')) {
    let location = { lat: 0, lng: 0 },
        mapMarkers = [],
        mapBounds = new google.maps.LatLngBounds(),
        mapInfoWindow = new google.maps.InfoWindow({
            maxWidth: 300,
            content: 'placeholder',
        });

    const map = new google.maps.Map(document.getElementById('groups-map'), {
        zoom: 2,
        minZoom: 2,
        center: location,
        scrollwheel: false,
    });

    document.querySelectorAll('.js-group-info').forEach(el => {
        // Do we have any filters to account for?
        let marker = new google.maps.Marker({
                position: { lat: parseFloat(el.dataset.lat), lng: parseFloat(el.dataset.lng) },
                map: map,
                title: el.dataset.name,
            }),
            infoContent =
                '<div class="groups__map-info-window"><h2>' +
                el.dataset.name +
                '</h2>' +
                el.innerHTML +
                '<p>' +
                el.dataset.address.replace(/(?:\r\n|\r|\n)/g, '<br />') +
                '</p></div>';

        marker.addListener('click', function() {
            mapInfoWindow.setContent(infoContent);

            mapInfoWindow.open(map, marker);
        });

        // Extend the maps bounds to include this markers position
        mapBounds.extend(marker.getPosition());
    });

    // Once we've setup all the markers we need to position and zoom the map
    map.fitBounds(mapBounds);
}
